<template>
  <div id="crumbs" class="wt-h-100" v-if="objItems">
    <div id="wt-loading" :class="{'wt-loading-show': showLoading}">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <!-- -BREADCRUMB -->
    <ul id="bpm-breadcrumb" v-if="!showLoading">
      <li>
        <span>{{objItems ? objItems.process_label : ""}}</span>
      </li>
      <li>
        <span>{{objItems ? objItems.task_label : ""}}</span>
      </li>
    </ul>
    <!-- FINISH - BREADCRUMB -->

    <transition mode="out-in">
      <b-form class="text-uppercase wt-task-form p-4" id="preview-form" v-if="objItem">
        <div class="task-col">
          <div class="form-task-list">
            <!-- -AUTOMATIC FORM -->
            <!-- Criação de formulários automática com base em resposta do banco -->
            <div class="form-row w-100" v-if="activeTask == objItem.bpm_task_id && inputs">
              <div
                v-for="(item, key) in sortInputs(this.inputs)"
                :key="key"
                class="col-md-12 col-lg-6 col-xl-4"
              >
                <!-- TYPE TEXT / COMMON -->
                <div class="form-group col-md-12 text" v-if="checktype(item.type) == 'text'">
                  <label for="item.id">{{item.label}}</label>
                  <input
                    :type="item.type"
                    :id="item.id"
                    v-model="objItemData[item.id]"
                    class="form-control"
                    :readonly="item.read_only"
                    :required="item.column_required"
                  />
                </div>

                <!-- TYPE SELECT -->
                <div class="form-group col-md-12 select" v-if="checktype(item.type) == 'select'">
                  <label for="item.id">{{item.label}}</label>
                  <select
                    :id="item.id"
                    v-model="objItemData[item.id]"
                    class="form-control"
                    :readonly="item.read_only"
                    :required="item.column_required"
                  >
                    <option
                      v-for="(opt, opt_key) in item.options"
                      :value="opt.value"
                      :key="key+'-'+opt_key"
                    >{{opt.text}}</option>
                  </select>
                </div>

                <!-- TYPE CHECKBOX -->
                <div
                  class="form-group col-md-12 checkbox"
                  v-if="checktype(item.type) == 'checkbox'"
                >
                  <label>{{item.label}}</label>
                  <div v-for="(check, check_key) in item.options" :key="key+'-'+check_key">
                    <input
                      :type="item.type"
                      :id="'id'+check_key"
                      :value="check.value"
                      v-model="objItemData[item.id]"
                      :readonly="item.read_only"
                      :required="item.column_required"
                    />
                    <label :for="'id'+check_key">{{check.text}}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- FINISH - AUTOMATIC FORM -->

            <!-- -HISTORIC TASKS -->
            <!-- Visualização dos dados de processos anteriores -->
            <div
              id="task-report"
              class="form-row w-100"
              v-if="activeTask != objItem.bpm_task_id && taskList[activeIndex]"
            >
              <div class="col-12">
                <p
                  class="w-100"
                  id="task-title"
                >{{taskList[activeIndex] ? taskList[activeIndex].task_label : ""}}</p>
              </div>

              <div class="col-md-12 col-lg-6 col-xl-4">
                <p class="w-100 task-label">Aberto em</p>
                <p
                  class="w-100 task-data"
                >{{taskList[activeIndex] ? taskList[activeIndex].open_task_dt : ""}}</p>
              </div>

              <div class="col-md-12 col-lg-6 col-xl-4">
                <p class="w-100 task-label">Encerrado em</p>
                <p
                  class="w-100 task-data"
                >{{taskList[activeIndex] ? taskList[activeIndex].close_task_dt : ""}}</p>
              </div>

              <div class="col-md-12 col-lg-6 col-xl-4">
                <p class="w-100 task-label">Encerrado por</p>
                <p
                  class="w-100 task-data"
                >{{taskList[activeIndex] ? taskList[activeIndex].close_user_name : ""}}</p>
              </div>

              <hr class="col-12" />
              <div
                class="col-md-12 col-lg-6 col-xl-4 task-column"
                v-for="column in sortInputs(taskList[activeIndex].columns)"
                :key="column.column_order"
              >
                <p class="w-100 task-label">{{column.task_column_label}}</p>
                <p class="w-100 task-data">{{column.value ? column.value : '-'}}</p>
              </div>

              <hr class="col-12 mb-0" />
            </div>
            <!-- FINISH - HISTORIC TASKS -->

            <!-- -BUTTONS -->
            <!-- Botões "CANCELAR" e "SALVAR" no rodapé da página -->
            <div class="form-row w-100" id="task-button-footer">
              <div class="form-group col-md-12 text-right">
                <!-- CANCELAR -->
                <b-button
                  id="btnCancel"
                  size="sm"
                  pill
                  variant="secondary"
                  class="mx-2 pr-3"
                  @click="forceCardListUpdate"
                  v-if="!showLoading"
                >
                  <i class="fa fa-undo mx-2"></i>
                  <strong class="wts-strong">CANCEL</strong>
                </b-button>

                <!-- SALVAR -->
                <b-button
                  id="btnSave"
                  size="sm"
                  pill
                  variant="primary"
                  class="mx-2 pr-3"
                  @click="save"
                  v-if="activeTask == objItem.bpm_task_id"
                >
                  <i class="fa fa-check-circle mx-2"></i>
                  <strong class="wts-strong">{{objItem.bpm_process_runner_id ? "SAVE" : "CREATE"}}</strong>
                </b-button>
              </div>
            </div>
            <!-- FINISH - BUTTONS -->
          </div>
          <!-- -TASK LIST -->
          <div class="historic-task-list" v-if="taskList && historic">
            <ul class="m-0">
              <li
                v-for="item in historic"
                :key="item.bpm_task_id"
                :class="activeTask==item.bpm_task_id?'active':''"
              >
                <b-button id="btn" class="w-100 text-left" @click="activeTask=item.bpm_task_id">
                  <span>
                    <i class="fas fa-caret-left mx-2"></i>
                    <strong class="wts-strong">{{item.task_label}}</strong>
                  </span>
                  <span v-if="item.close_task_dt">
                    <i class="fa fa-check mx-2"></i>
                  </span>
                </b-button>
              </li>
            </ul>
          </div>
          <!-- FINISH - TASK LIST -->
        </div>
        <!-- <pre style="font-size: .6em; text-align: left; text-transform: lowercase">{{taskList}}</pre>-->
        <pre style="font-size: .6em; text-align: left; text-transform: initial">{{objItem}}</pre>
      </b-form>
    </transition>
  </div>
</template>

<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

export default {
  name: "BpmHomeTaskEdit",
  props: {
    objItems: Object,
    taskList: Object
  },
  components: {},
  computed: {
    showLoading() {
      return this.$store.state.loading.showLoading;
    }
  },
  data: function() {
    return {
      primary_key: "bpm_process_runner_id",
      // result
      objItem: {},
      objItemData: {},
      nameObjData: "columns",

      listOfColumns: [],
      historic: [],
      inputs: [],
      activeTask: "",
      activeIndex: ""
    };
  },
  methods: {
    // Adapt code to form gen
    generateInputsArray() {
      if (this.objItems && !this.isEmpty(this.objItems)) {
        this.listOfColumns = Object.keys(this.objItems.inputs).map(key => {
          return this.objItems.inputs[key];
        });

        let obj = [];
        this.listOfColumns.forEach(element => {
          this.inputs = [];
          let label = element.task_column_label;
          let name = element.task_column_name;
          let type = "";
          let readOnly = false;
          let columnRequired = false;
          let column_order = element.column_order;

          if (element.read_only == "Y") readOnly = true;
          if (element.column_required == "Y") columnRequired = true;

          switch (element.column_type.toLowerCase()) {
            case "varchar":
              type = "text";
              break;
            case "integer":
              type = "number";
              break;
            case "timestamp":
              type = "date";
              break;
            default:
              // none;
              break;
          }

          obj.push({
            type: type,
            id: name,
            label: label,
            read_only: readOnly,
            column_required: columnRequired,
            column_order: column_order
          });
        });
        this.inputs = obj;
      } else {
        this.inputs = [];
      }
    },

    // Defines de type of input to HTML mount
    checktype(type) {
      if (
        [
          "text",
          "password",
          "number",
          "email",
          "url",
          "date",
          "datetime-local",
          "hidden",
          "time"
        ].includes(type)
      )
        return "text";
      if (["select"].includes(type)) return "select";
      if (["checkbox"].includes(type)) return "checkbox";
      return null;
    },

    /**
     * /src/widgets/context-menu/Toolbars.vue
     * Line: 235
     * Method: Save
     */
    save() {
      let urlServices, apiAction, method;
      // Update urlService
      if (this.objItem.bpm_process_runner_id != "") {
        urlServices = "chameleon-ds/api/internal/bpm-process-runner";
        apiAction = "update-task";
        method = "post";
      } else {
        urlServices = "chameleon-ds/api/internal/bpm-process-runner";
        apiAction = "insert";
        method = "post";
      }

      // Connection
      axios[method](
        `${baseApiUrl}:${baseApiPort}/${urlServices}/${apiAction}/`,
        this.objItem
      )
        .then(res => {
          // Alert
          console.log("status", res.status);
          this.$store.commit("alert/setShowAlert", true);
          this.$store.commit(
            "alert/setMessage",
            "Request ID: " + this.objItem.bpm_process_runner_id
          );
          this.$store.commit("alert/setSuccessvariant");

          this.forceCardListUpdate();
        })
        .catch(error => {
          // Alert
          this.$store.commit("alert/setShowAlert", true);
          this.$store.commit("alert/setMessage", error.response.data);
          this.$store.commit("alert/setDangervariant");

          this.forceCardListUpdate();
        });
    },

    forceCardListUpdate() {
      this.$emit("forceCardListUpdate", true);
    },

    /* General */
    sortInputs(arr) {
      // converte objeto para array
      if (!Array.isArray(arr)) arr = Object.values(arr);
      if (arr) {
        return arr.slice().sort(function(a, b) {
          return a.column_order > b.column_order ? 1 : -1;
        });
      } else {
        return null;
      }
    },

    isEmpty(obj) {
      for (let x in obj) {
        return false;
      }
      return true;
    },

    array_move(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    },

    /* Historic View */
    getHistoric() {
      if (this.taskList) {
        this.historic = [];
        for (var task in this.taskList) {
          if (
            this.taskList[task].close_task_dt ||
            this.taskList[task].bpm_task_id == this.objItem.bpm_task_id
          ) {
            this.historic.push(this.taskList[task]);
          }
        }
        this.sortHistoric();
      } else {
        return null;
      }
    },

    sortHistoric() {
      let max = this.historic.length - 1;

      let i = 0;
      while (i < this.historic.length) {
        const predecessors = this.historic[i].task_id_predecessors;

        // Predecessor não existe
        if (!predecessors) {
          // Não está na ultima posição da lista
          if (i != max) {
            // Seta a posição na array e reinicia a varredura
            this.array_move(this.historic, i, max);
            i = 0;
          } else {
            i++;
          }
        } else {
          // Realiza um novo loop para encontrar o predecessor
          for (let j = 0; j < this.historic.length; j++) {
            const compare = this.historic[j].bpm_task_id;
            // Faz a comparação
            if (predecessors.includes(compare)) {
              if (i != j - 1) {
                // Seta a posição na array e reinicia a varredura
                this.array_move(this.historic, i, j - 1);
                i = -1;
              }
              // Encerra o segundo loop
              break;
            }
          }
          i++;
        }
      }
    }
  },
  mounted() {
    this.generateInputsArray();
    // To mount checkbox its necessary to set the var to array
    this.inputs.forEach(element => {
      if (["checkbox"].includes(element.type)) {
        this.$set(this.objItem, element.id, []);
      }
    });
  },
  watch: {
    objItems() {
      this.objItem = {};
      if (this.objItems) {
        this.activeTask = this.objItems.bpm_task_id;
        this.objItem.bpm_process_id = this.objItems.bpm_process_id;
        this.objItem.bpm_process_version_id = this.objItems.bpm_process_version_id;
        this.objItem.bpm_task_id = this.objItems.bpm_task_id;
        this.objItem.bpm_process_runner_id = this.objItems.bpm_process_runner_id
          ? this.objItems.bpm_process_runner_id
          : "";
        this.objItem.task_name = this.objItems.task_name;
        this.getHistoric();
      }
      this.generateInputsArray();
    },
    activeTask() {
      for (var task in this.taskList) {
        if (this.taskList[task].bpm_task_id == this.activeTask) {
          this.activeIndex = task;
        }
      }
    },
    objItemData() {
      this.objItem[`${this.nameObjData}`] = this.objItemData;
    }
  }
};
</script>